import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-reset-token',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './reset-token.component.html',
  styleUrl: './reset-token.component.scss'
})
export class ResetTokenComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/reset-token-edit/';
  override addLink = '/dashboard/reset-token-create';


  managerList: Record<string, string> = {};
  managerListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('reset-token');
    this.crudService.orderBy = 'sendAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Token',
        field: 'token',
        sortable: true,
        filterType: EFilterType.TEXT,
        value: (item) => item.token.slice(0, 3) + '...' + item.token.slice(-3),
      },
      {
        header: 'Attempts',
        field: 'attempts',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Send At',
        field: 'sendAt',
        sortable: true,
        filterType: EFilterType.DATE,
        value: (item) => (new Date(item.sendAt || Date.now())).toLocaleString(),
        crudFilterType: ECrudFilterType.DATE,
      },
      {
        header: 'Manager',
        field: 'managerId',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: valueFromList(this, 'managerList', 'managerId'),
        options: () => this.managerListMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('manager', 'id', 'nickname').then(data => {
      this.managerList = data;
      // console.log('heeeeeeeeeeeeeeeeeeeeere', data);

      this.managerListMap = listFromMap(data);

      this.cdr.detectChanges();
    });

  }
}
